<div class="container-fluid px-lg-5 px-3 my-4 category-page">

    <!-- ===================== CATEGORY FORM ===================== -->
    <div class="card shadow-lg border-0">
        <div class="card-header bg-primary text-white fw-semibold">
            {{ isEditMode ? 'Update Category' : 'Add New Category' }}
        </div>

        <div class="card-body" [formGroup]="categoryForm">

            <!-- ===================== MAIN DETAILS ===================== -->
            <div class="row g-1 mb-4">

                <!-- CATEGORY NAME -->
                <div class="col-md-6 form-floating">
                    <input type="text" class="form-control" placeholder="Category Name" formControlName="categoryName"
                        (input)="onCategoryInput($event)">
                    <label>Category Name <span class="text-danger"><span class="text-danger">*</span></span></label>

                    <span class="text-danger small" *ngIf="categoryForm.get('categoryName')?.touched &&
                       categoryForm.get('categoryName')?.errors">

                        <span *ngIf="categoryForm.get('categoryName')?.errors?.['required']">
                            Category name is required
                        </span>
                        <span *ngIf="categoryForm.get('categoryName')?.errors?.['minlength']">
                            Minimum 3 characters required
                        </span>
                        <span *ngIf="categoryForm.get('categoryName')?.errors?.['pattern']">
                            Only letters allowed
                        </span>
                    </span>
                </div>

                <!-- BULK INSERT -->
                <div class="col-12 col-sm-6 col-lg-3 form-floating">
                    <select class="form-select" formControlName="isBulkInsert">
                        <option [ngValue]="true">Yes</option>
                        <option [ngValue]="false">No</option>
                    </select>
                    <label>Bulk Insert <span class="text-danger"><span class="text-danger">*</span></span></label>

                    <span class="text-danger small" *ngIf="categoryForm.get('isBulkInsert')?.touched &&
                       categoryForm.get('isBulkInsert')?.invalid">
                        Bulk insert selection required
                    </span>
                </div>

                <!-- COD AVAILABLE -->
                <div class="col-12 col-sm-6 col-lg-3 form-floating">
                    <select class="form-select" formControlName="isCodAvailable" (change)="selectCodValue($event)">
                        <option [ngValue]="true">Yes</option>
                        <option [ngValue]="false">No</option>
                    </select>
                    <label>COD Available <span class="text-danger"><span class="text-danger">*</span></span></label>

                    <span class="text-danger small" *ngIf="categoryForm.get('isCodAvailable')?.touched &&
                       categoryForm.get('isCodAvailable')?.invalid">
                        COD availability required
                    </span>
                </div>

                <div class="mb-4">

                    <div class="d-flex justify-content-between align-items-center mb-2">
                        <h6 class="fw-semibold mb-0">Sub Categories Details</h6>

                        <button class="btn btn-success btn-sm" type="button" (click)="addSubCategoryRow()">
                            Add Sub Category <i class="fa fa-plus"></i>
                        </button>
                    </div>

                    <div formArrayName="subCategories">
                        <div *ngFor="let sub of subCategories.controls; let i = index" [formGroupName]="i"
                            class="row mb-2">

                            <div class="col-md-6 form-floating mb-2">
                                <input type="text" class="form-control" placeholder="Enter Sub Category"
                                    formControlName="subCategoryName">
                                <label>Sub Category Name</label>
                            </div>

                            <div class="col-md-4">
                                <button type="button" class="btn btn-danger" (click)="removeSubCategoryRow(i)">
                                    Remove <i class="fa fa-trash"></i>
                                </button>
                            </div>

                        </div>
                    </div>
                    <!-- DUPLICATE ERROR -->
                    <span class="text-danger small" *ngIf="hasDuplicateSubCategory()">
                        Duplicate Sub Categories not allowed
                    </span>

                </div>

            </div>

            <!-- ===================== COD DETAILS ===================== -->
            <div class="row g-1 align-items-end mb-2">

                <div class="d-flex justify-content-between align-items-center mb-2"
                    *ngIf="categoryForm.get('isCodAvailable')?.value">
                    <h6 class="fw-semibold mb-0">COD Details</h6>
                    <!-- ADD BUTTON AT HEADER -->
                    <button class="btn btn-success btn-sm" type="button" (click)="addCodRow()">
                        Add COD <i class="fa fa-plus"></i>
                    </button>
                </div>

                <div formArrayName="codDetailsList" *ngIf="categoryForm.get('isCodAvailable')?.value">
                    <div class="row g-3 align-items-end mb-2" *ngFor="let cod of codDetailsList.controls; let i = index"
                        [formGroupName]="i">

                        <div class="col-12 col-sm-6 col-lg-3 form-floating">
                            <input type="number" class="form-control" min="0" placeholder="COD Amount"
                                formControlName="codAmount">
                            <label>COD Amount <span class="text-danger">*</span></label>
                            <span class="text-danger small" *ngIf="cod.get('codAmount')?.touched &&
                       cod.get('codAmount')?.invalid">
                                COD amount is required
                            </span>
                        </div>

                        <div class="col-12 col-sm-6 col-lg-3 form-floating">
                            <input type="number" class="form-control" min="0" placeholder="Additional Amount"
                                formControlName="additionalAmount">
                            <label>Additional Amount <span class="text-danger">*</span></label>
                            <span class="text-danger small" *ngIf="cod.get('additionalAmount')?.touched &&
                       cod.get('additionalAmount')?.invalid">
                                Additional Amount is required
                            </span>
                        </div>


                        <div class="col-md-2 d-flex gap-2">
                            <button class="btn btn-danger btn-sm" type="button" *ngIf="codDetailsList.length > 1"
                                (click)="removeCodRow(i)">Remove <i class="fa fa-trash"></i></button>
                        </div>
                    </div>
                </div>

                <!-- ===================== SHIPPING DETAILS ===================== -->
                <h6 class="fw-semibold g-3 mb-2 d-flex justify-content-between align-items-center">
                    Shipping Details
                    <!-- ADD BUTTON AT HEADER -->
                    <button class="btn btn-success btn-sm" type="button" (click)="addShippingRow()">
                        Add Shipping <i class="fa fa-plus"></i>
                    </button>
                </h6>

                <div formArrayName="shippingList">

                    <div class="card shadow-sm mb-3" *ngFor="let ship of shippingList.controls; let i = index"
                        [formGroupName]="i">

                        <div class="card-body">

                            <!-- ROW 1 -->
                            <div class="row g-3 align-items-end">

                                <!-- Shipping Partner -->
                                <div class="col-12 col-sm-6 col-lg-3 form-floating">
                                    <input type="text" class="form-control" placeholder="Shipping Partner"
                                        formControlName="shippingPartner">
                                    <label>Shipping Partner </label>

                                    <span class="text-danger small" *ngIf="ship.get('shippingPartner')?.touched &&
                       ship.get('shippingPartner')?.invalid">
                                        Shipping Partner is required
                                    </span>
                                </div>

                                <!-- Shipping Type -->
                                <div class="col-12 col-sm-6 col-lg-3 form-floating">
                                    <select class="form-select" formControlName="shippingType">
                                        <option value="">Select</option>
                                        <option value="FREE">FREE</option>
                                        <option value="PAID">PAID</option>
                                    </select>
                                    <label>Shipping Type <span class="text-danger">*</span></label>
                                </div>

                                <!-- State -->
                                <div class="col-12 col-sm-6 col-lg-3 form-floating">
                                    <select class="form-select" formControlName="state">
                                        <option value="">Select State</option>
                                        <option *ngFor="let s of states" [value]="s">{{ s }}</option>
                                    </select>
                                    <label>State <span class="text-danger">*</span></label>

                                    <span class="text-danger small"
                                        *ngIf="ship.get('state')?.touched && ship.get('state')?.invalid">
                                        State is required
                                    </span>
                                </div>

                                <!-- Rate type -->
                                <div class="col-12 col-sm-6 col-lg-3 form-floating">
                                    <select class="form-select" formControlName="rateType">
                                        <option value="">Select Rate type</option>
                                        <option *ngFor="let s of rateDetails" [value]="s">{{ s }}</option>
                                    </select>
                                    <label>Rate type <span class="text-danger">*</span></label>

                                    <span class="text-danger small"
                                        *ngIf="ship.get('rateType')?.touched && ship.get('rateType')?.invalid">
                                        Rate type is required
                                    </span>
                                </div>
                            </div>

                            <!-- ROW 2 -->
                            <div class="row g-3 align-items-end mt-2">

                                <!-- Shipping Amount -->
                                <div class="col-12 col-sm-6 col-lg-3 form-floating">
                                    <input type="number" class="form-control" min="0" step="1" inputmode="numeric"
                                        placeholder="Shipping Amount" formControlName="shippingAmount">
                                    <label>Shipping Amount <span class="text-danger">*</span></label>
                                </div>

                                <!-- Start Range -->
                                <div class="col-12 col-sm-6 col-lg-3 form-floating">
                                    <input type="number" class="form-control" min="0" step="1" inputmode="numeric"
                                        pattern="[0-9]*" placeholder="Start Range" formControlName="productStartRange">
                                    <label>Start Range <span class="text-danger">*</span></label>
                                </div>

                                <!-- End Range -->
                                <div class="col-12 col-sm-6 col-lg-3 form-floating">
                                    <input type="number" class="form-control" min="0" step="1" inputmode="numeric"
                                        pattern="[0-9]*" placeholder="End Range" formControlName="productEndRange">
                                    <label>End Range <span class="text-danger">*</span></label>
                                </div>

                                <!-- ACTION BUTTONS -->
                                <div class="col-md-2 d-flex gap-2">
                                    <button type="button" class="btn btn-danger btn-sm px-3"
                                        *ngIf="shippingList.length > 1" (click)="removeShippingRow(i)">Remove
                                        <i class="fa fa-trash"></i>
                                    </button>
                                </div>

                            </div>

                            <!-- ERRORS (FULL WIDTH, CLEAN ALIGNMENT) -->
                            <div class="row mt-2">
                                <div class="col-12">

                                    <!-- RANGE ERROR -->
                                    <span class="text-danger small d-block"
                                        *ngIf="ship.errors?.['rangeInvalid'] && ship.touched">
                                        End range must be greater than start range
                                    </span>

                                    <!-- DUPLICATE ERROR -->
                                    <span class="text-danger small d-block"
                                        *ngIf="getDuplicateShippingPartner(i) as partner">
                                        Duplicate shipping range for <b>{{ partner }}</b> not allowed
                                    </span>

                                </div>
                            </div>

                        </div>
                    </div>

                </div>


                <!-- ===================== SAVE ===================== -->
                <div class="text-center mt-4">
                    <button type="button" class="btn btn-success px-4" (click)="save()"
                        [disabled]="hasDuplicateShipping()">
                        {{ isEditMode ? 'Update Category' : 'Save Category' }}
                    </button>
                </div>

            </div>
        </div>
    </div>

    <!-- ===================== CATEGORY LIST ===================== -->
    <div class="card shadow-lg border-0 mt-4">
        <div class="card-header bg-dark text-white d-flex align-items-center">
            <span>Category List</span>
            <input type="text" class="form-control form-control-sm w-25 ms-2" placeholder="🔍 Search..."
                [(ngModel)]="searchText">
        </div>

        <div class="table-responsive" style="max-height:300px">
            <table class="table table-hover mb-0 text-center">
                <thead class="table-light sticky-top">
                    <tr>
                        <th>#</th>
                        <th>Category Name</th>
                        <th>Bulk Insert</th>
                        <th>COD Available</th>
                        <th>Status</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let c of categoryList | filter:searchText; let i=index">
                        <td>{{ i + 1 }}</td>
                        <td>{{ c.categoryName || "-"}}</td>
                        <td>{{ c.isBulkInsert ? 'Yes' : 'No' }}</td>
                        <td>{{ c.isCodAvailable ? 'Yes' : 'No' }}</td>
                        <td>
                            <select class="form-select form-select-sm" [ngModel]="c.status"
                                (ngModelChange)="onStatusChange(c, $event)">

                                <option value="Active">Active</option>
                                <option value="InActive">InActive</option>

                            </select>
                        </td>
                        <td>
                            <button class="btn btn-warning btn-sm" (click)="edit(c)">
                                Edit
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>